import { useEffect, useState } from 'react';

const STORAGE_KEY = 'pinkpeach_history';
const CHANGE_EVENT = 'pinkpeach-history-change';
const MAX_ITEMS = 12;

function readHistory(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((id) => typeof id === 'string') : [];
  } catch {
    return [];
  }
}

/**
 * 本地缓存浏览历史（仅存于当前浏览器）。
 */
export function useBrowseHistory() {
  const [history, setHistory] = useState<string[]>([]);

  useEffect(() => {
    setHistory(readHistory());
    const handler = () => setHistory(readHistory());
    window.addEventListener(CHANGE_EVENT, handler);
    return () => window.removeEventListener(CHANGE_EVENT, handler);
  }, []);

  const pushHistory = (id: string) => {
    const current = readHistory();
    const next = [id, ...current.filter((item) => item !== id)].slice(0, MAX_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    window.dispatchEvent(new Event(CHANGE_EVENT));
  };

  return { history, pushHistory };
}

export default useBrowseHistory;